var tib = tib || {};
tib.login = tib.login || {};

tib.login = (function($) {
// tib.login = (function($, templates) {
    'use strict';
    var exports = {};

    /**
     * get all the button clicks setup for login
     */
    function setupButtonClicks() {
        $(document).on('click', '.login-form-submit',exports.submit);
        $(document).on('keypress', '.login-text-box',exports.enterSubmit);
    }

    exports.enterSubmit = function(event) {
        if (event && event.which && event.which === 13)
        {
            exports.submit();
        }
    };

    /**
     * Submit user and password to the server
     */
    exports.submit = function () {
        let $loginFormMessage = $('.login-form-message');
        let animationSpeed = 50;
        $loginFormMessage.slideUp(animationSpeed);
        let $loginFormRedirectContainer = $('.login-form-redirect-container');
        $loginFormRedirectContainer.slideUp(animationSpeed);
        let $button = $(this);
        let $spinner = $('<i class="fa fa-refresh fa-spin for-red-button"></i>');
        $button.append($spinner).prop('disabled', true).addClass('disabled');
        let username = $('.login-form-user').val();
        let password = $('.login-form-password').val();
        if (username !== null && password !== null) {
            $.ajax({
                url: '/api/login',
                data: {
                    username: username,
                    password: password,
                },
                type: 'POST'
            }).done(function (response) {
                $spinner.remove();
                $button.attr('disabled', false).removeClass('disabled');
                if (response) {
                    $loginFormMessage.slideDown(100);
                    $loginFormMessage.show().text(response.Message);
                    if (response.Success === false) {
                        $loginFormMessage.addClass('alert-danger').removeClass('alert-success');
                        return;
                    }
                    $loginFormMessage.addClass('alert-success').removeClass('alert-danger');
                    let roles = [];
                    for (let key in response.User) {
                        if (!response.User.hasOwnProperty(key) || response.User[key] === false) {
                            continue;
                        }
                        switch (key) {
                            case 'IsSiteAdmin':
                            case 'IsRootAdmin':
                            case 'IsBlogAdmin':
                            case 'IsSuperAdmin':
                                roles.push(key);
                                break;
                        }
                    }
                    switch (roles.length) {
                        case 0:
                            window.top.location = 'basic.php';
                            break;
                        case 1:
                            switch (roles[0]) {
                                case 'IsSiteAdmin':
                                    window.top.location = 'basic.php';
                                    break;
                                case 'IsRootAdmin':
                                    window.top.location = 'admin.php';
                                    break;
                                case 'IsBlogAdmin':
                                    window.top.location = 'blog-admin.php';
                                    break;
                            }
                            break;
                        default:
                            $loginFormRedirectContainer.html(tib.template['public/login-form-redirect'](response));
                            $loginFormRedirectContainer.slideDown(animationSpeed);
                    }
                }
            });
        }
    };

    exports.init = function() {
        $('.login-form-container').html(tib.template['public/login-form']);
        $('.login-form-message').hide();
        setupButtonClicks();
    };


    return exports;
})(jQuery);
// })(jQuery, tib.template);


$(document).ready(function() {
    'use strict';
    Handlebars.registerHelper('iff', function (v1, operator, v2, options) {
        switch (operator) {
            case '==':
                return (v1 == v2) ? options.fn(this) : options.inverse(this);
            case '===':
                return (v1 === v2) ? options.fn(this) : options.inverse(this);
            case '!=':
                return (v1 != v2) ? options.fn(this) : options.inverse(this);
            case '!==':
                return (v1 !== v2) ? options.fn(this) : options.inverse(this);
            case '<':
                return (v1 < v2) ? options.fn(this) : options.inverse(this);
            case '<=':
                return (v1 <= v2) ? options.fn(this) : options.inverse(this);
            case '>':
                return (v1 > v2) ? options.fn(this) : options.inverse(this);
            case '>=':
                return (v1 >= v2) ? options.fn(this) : options.inverse(this);
            case '&&':
                return (v1 && v2) ? options.fn(this) : options.inverse(this);
            case '||':
                return (v1 || v2) ? options.fn(this) : options.inverse(this);
            default:
                return options.inverse(this);
        }
    });
    tib.login.init();
});
